import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Heading, Heading2 } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const CUSTOM_WIDTH_MAX = '842px'
const CUSTOM_WIDTH_MIN = '750px'

export const EtfContainer = styled.div<{
  disabled: boolean
}>`
  display: flex;
  align-items: center;
  height: 88px;
  ${props =>
    props.disabled &&
    `
        color: ${style(theme => theme.colors.white)};
        opacity: 0.4;
      `}
  @media screen and (max-width: 660px) {
    justify-content: center;
  }
`

export const Value = styled.div`
  font-size: 14px;
  color: ${style(theme => theme.colors.green)};
  font-weight: 600;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-right: 0px;
  }
`

export const Label = styled.div<{ isBold?: boolean }>`
  font-size: 14px;
  color: ${style(theme => theme.colors.slate)};
  overflow: hidden;
  margin-right: auto;
  ${props =>
    props.isBold &&
    `
      font-weight: 600;
    `};
`

export const EtfSymbol = styled(Heading2)`
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
  color: ${style(theme => theme.colors.stone)};
`

export const TitleContainer = styled.div<{ hasEtfPercent: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  ${props => (props.hasEtfPercent ? 'width: 156px;' : 'width: 195px;')}
  margin-right: 20px;
  @media screen and (min-width: ${CUSTOM_WIDTH_MIN}) and (max-width: ${CUSTOM_WIDTH_MAX}) {
    width: 149px;
  }
`

export const EtfListContainer = styled.div`
  width: 100%;
  display: grid;
  /* Note: Allow each child to grow as much as they want with min widths of 290px (will wrap after)*/
  grid-template-columns: repeat(auto-fit, minmax(290px, auto));
  grid-column-gap: 80px;
  grid-area: auto;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    grid-column-gap: 20px;
    grid-column-gap: 10px;
    justify-content: center;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: block;
  }
`

export const EtfListHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`

export const EtfListHeaderTitle = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
`

export const EtfListHeaderEtfCount = styled(Bodytext)`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: ${style(theme => theme.colors.stone)};
`

export const Container = styled.div`
  width: 100%;
  padding: 20px 0px 50px;
`

export const StyledEtfSymbol = styled(AcornsIcon)`
  margin-right: 15px;
`
